import { apiConfig } from '../api-config';

export interface CreateReportTermParams {
  nameMain: string;
  document: string;
  tokenKey: string;
  cdTerritory: string;
  carNumber: string;
  territoryName: string;
  street: string;
  number: string;
  complement: string;
  city: string;
  state: string;
  cep: string;
  email: string;
  telephone: string;
  cdAgent: string;
  representativeName?: string;
  representativePosition?: string;
  representativeDocumentNumber?: string;
  isAssing: boolean;
}

export const createReportTerm = async (params: CreateReportTermParams) => {
  return apiConfig
    .post('/api/TermCommitment/download', params)
    .then((resp) => resp.data.objectResult)
    .catch((err) => ({ hasErrors: true, message: err.message }));
};
